<template>
  <div class="profile">
    <h1>My profile</h1>
  </div>
</template>

<script>
export default {
  
};
</script>

<style scoped>
</style>
